
export const ActionData = (data, dispatch) => {
    dispatch({
        type: "DATA",
        payload: data
    })
}